import React from 'react';

const ReleaseUnavailable = () => (
  <div style={{ padding: 32 }}>
    <h2 style={{ marginBottom: 12 }}>Not available in this release</h2>
    <p style={{ margin: 0 }}>
      This admin module is outside the current launch scope and has been temporarily disabled.
    </p>
  </div>
);

export default ReleaseUnavailable;
